var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 373,
    viewBox: "0 0 302 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0H0V11V279.812V283.094L1.79881 285.84L49.4456 358.567L58.6478 372.613L67.8486 358.566L115.354 286.039L117.151 283.296L117.153 280.017L117.282 11.0053L117.287 0H106.282H11ZM22 61.6737V22H95.2765L95.2575 61.6737H22ZM22 83.6737V276.53L58.6458 332.465L95.1542 276.727L95.2469 83.6737H22Z",
    fill: "url(#paint0_linear_937_12907)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.366 0.000976562H140.366V11.001V359.001V370.001H151.366H290.524H301.592L301.524 358.933L299.362 10.9327L299.294 0.000976562H288.362H151.366ZM162.366 79.8849V22.001H277.431L279.455 348.001H162.366V289.84H213.734V267.84H162.366V195.862H217.25V173.862H162.366V101.885H217.25V79.8849H162.366Z",
    fill: "url(#paint1_linear_937_12907)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_937_12907",
    x1: -5.83338,
    y1: -25,
    x2: 244.208,
    y2: 99.0199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#7A8AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#4E63E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223CDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_937_12907",
    x1: 132.347,
    y1: -24.8237,
    x2: 423.401,
    y2: 175.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#7A8AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#4E63E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223CDD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.1cf29a8e5dd5ea7dd9463ac59b708db9.svg";
export { ForwardRef as ReactComponent };